/** Minimum time between challenge issue and form submit. */
export const FORM_CHALLENGE_MIN_FILL_MS = 3000;

/** Challenges older than this are rejected (replay window). */
export const FORM_CHALLENGE_MAX_AGE_MS = 2 * 60 * 60 * 1000;
